/* lystia-product-card.js - поведінка картки товару (T-E2-20, parity/snippets.md §8.3-8.4, parity/quickadd.md §2).
   Підключення: <script src="{{ 'lystia-product-card.js' | asset_url }}" defer> (snippets/product-card.liquid; повторні підключення ігноруються).
   Делегування на document: працює для карток, вставлених пізніше (фільтри, Section Rendering).
   API: window.LystiaProductCard.setQuickState(card, 'default'|'loading'|'added'|'error') - для шторки quickadd (T-E3-05).
   Залежності (за наявності): window.LystiaCart (add), document.lystiaToast (show), document.lystiaOverlay (has/open),
   window.LystiaFavorites (тоггл ♥ робить сам; тут лише тост на fav:change від кліку по .pcard__fav). */
(function () {
  'use strict';
  if (window.LystiaProductCard) return;

  var ADDED_MS = 2000;
  var ERROR_MS = 2500;
  var STATES = ['q-loading', 'q-added', 'q-error'];
  var timers = new WeakMap();

  function toast(text, opts) {
    if (text && document.lystiaToast && typeof document.lystiaToast.show === 'function') document.lystiaToast.show(text, opts || {});
  }

  /* default | loading | added (2000 мс) | error (2500 мс): клас на картці + disabled/aria-busy на «+» */
  function setQuickState(card, state) {
    if (!card) return;
    clearTimeout(timers.get(card));
    STATES.forEach(function (c) { card.classList.remove(c); });
    var quick = card.querySelector('.pcard__quick');
    var cta = card.querySelector('.pcard__cta'); /* кнопка набору D (T-E2-21): те саме, але стан loading = is-loading */
    var btns = [quick, cta].filter(Boolean);
    if (!btns.length) return;
    btns.forEach(function (b) { b.disabled = state === 'loading'; b.classList.toggle('is-loading', state === 'loading' && b === cta); });
    if (state === 'loading') {
      card.classList.add('q-loading');
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    } else {
      btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
      if (state === 'added' || state === 'error') {
        card.classList.add(state === 'added' ? 'q-added' : 'q-error');
        timers.set(card, setTimeout(function () { setQuickState(card, 'default'); }, state === 'added' ? ADDED_MS : ERROR_MS));
      }
    }
  }

  function openCart(quick) {
    var ov = document.lystiaOverlay;
    if (ov && typeof ov.has === 'function' && ov.has('cart')) ov.open('cart');
    else if (quick.dataset.cartUrl) window.location.assign(quick.dataset.cartUrl);
  }

  async function quickAdd(card, quick) {
    if (card.classList.contains('q-loading')) return; /* повторний tap під час loading ігноруємо */
    var ov = document.lystiaOverlay;
    var count = Number(quick.dataset.availableCount) || 0;
    if (count > 1 && ov && typeof ov.has === 'function' && ov.has('quickadd')) {
      ov.open('quickadd', { handle: card.dataset.handle, card: card });
      return;
    }
    var id = Number(quick.dataset.variantId);
    if (!id) return;
    setQuickState(card, 'loading');
    try {
      if (!window.LystiaCart) throw new Error('cart');
      await window.LystiaCart.add({ id: id, quantity: 1 });
      setQuickState(card, 'added');
      toast(quick.dataset.textAdded, {
        icon: 'check',
        action: { label: quick.dataset.textCart, onClick: function () { openCart(quick); } },
      });
    } catch (e) {
      setQuickState(card, 'error');
      toast(quick.dataset.textFailed, { icon: 'alert' });
    }
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var quick = target.closest('.pcard__quick, .pcard__cta');
    if (quick) {
      e.preventDefault();
      e.stopPropagation();
      var card = quick.closest('.pcard');
      if (card) quickAdd(card, quick);
      return;
    }
    /* тост ♥ лише для кліку по кнопці картки (не для ♥ на PDP тощо); тоггл виконує lystia-favorites.js */
    var fav = target.closest('.pcard__fav');
    if (fav) pendingFav = fav;
  }, true);

  var pendingFav = null;
  document.addEventListener('fav:change', function (e) {
    var btn = pendingFav;
    pendingFav = null;
    if (!btn || !e.detail || e.detail.reason !== 'toggle') return;
    var on = !!e.detail.active;
    toast(on ? btn.dataset.textAdded : btn.dataset.textRemoved, {
      icon: on ? 'heart-fill' : 'heart',
      action: on && btn.dataset.favUrl ? { label: btn.dataset.textView, href: btn.dataset.favUrl } : null,
    });
  });

  /* Фото не завантажилось -> порожній plate-блок (.is-nophoto) */
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG' || !img.classList.contains('pcard__img')) return;
    var card = img.closest('.pcard');
    img.remove();
    if (card) card.classList.add('is-nophoto');
  }, true);

  window.LystiaProductCard = Object.freeze({ setQuickState: setQuickState });
})();
